import React from 'react';
import FadeIn from '../common/FadeIn';
import homeHeroImg from '../../assets/images/homeHero.png';

const HeroSection = () => {
  return (
    <section className="w-full bg-[#f9f9f5] px-[13px] md:px-[25px] lg:px-10">
      <FadeIn>
        <div
          className="relative w-full hero-responsive-height bg-cover bg-center bg-no-repeat overflow-hidden flex flex-col md:flex-row items-start md:items-end justify-end md:justify-between p-6 sm:p-8 md:px-[40px] md:h-screen lg:h-screen md:pb-[50px] lg:pl-[77px] lg:pr-[56px] lg:pb-[140px] gap-6 md:gap-8"
          style={{
            backgroundImage: `linear-gradient(180deg, transparent 0%, #070707d9 100%), url(${homeHeroImg})`,
          }}
        >
          <FadeIn className="z-10 max-w-full md:max-w-[55%] lg:max-w-[650px]">
            <h1 className="font-saolDisplayItalic text-left text-[white] text-[33px] md:text-[58px] font-normal leading-[1.1] tracking-[0em]">
              Simple{" "}
              <span className="font-PromenadeItalic">websites</span> for <br />
              brands with{" "}
              <span className="font-PromenadeItalic">personality.</span>
            </h1>
          </FadeIn>

          <FadeIn className="z-10 md:mb-1 mb-[20px] md:max-w-[280px] lg:max-w-[340px]">
            <div className="font-interDisplayMedium text-white leading-[1.6] text-[12px] md:text-[16px] md:text-right tracking-[0.02em] font-light">
              <p>
                For creatives and wedding professionals who want a website that feels like their own.
              </p>
            </div>
          </FadeIn>
        </div>
      </FadeIn>
    </section>
  );
};

export default HeroSection;